import { render } from "./MandatoryIcon.vue?vue&type=template&id=4e3b5aef&scoped=true"
const script = {}

import "./MandatoryIcon.vue?vue&type=style&index=0&id=4e3b5aef&scoped=true&lang=css"

import exportComponent from "F:\\XAMPP_NEW\\htdocs\\ASRHAVELI\\delivery\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3b5aef"]])

export default __exports__